module.exports = __webpack_public_path__ + "static/media/synth_17.9f56bfd2.mp3";